import { User } from 'interfaces';

import { firebaseAuth } from 'lib/firebase/firebase.client';
import { authStoreActions } from 'modules/auth/store/authStore/actions';
import { isCanceled, isOnTrial, isPremium } from 'modules/subscription/utils/checkers';

export const getUserSubscriptionState = (user: User | null) => {
  const isTrialUser = user ? isOnTrial(user) : false;
  const isPremiumUser = !isTrialUser && isPremium(user);
  const isFreeUser = !isTrialUser && !isPremiumUser;
  const isCanceledUser = isCanceled(user);

  return { isTrialUser, isPremiumUser, isFreeUser, isCanceledUser, hasPremium: isTrialUser || isPremiumUser };
};

export const reloadUserData = async () => {
  await firebaseAuth.currentUser?.reload?.();
  return await authStoreActions.setUser(firebaseAuth.currentUser, { force: true });
};
